import PropTypes from 'prop-types'
import React from 'react'
import Icon from './Icon'

const formatTime = timeInSeconds => {
  const seconds = Math.floor(timeInSeconds) % 60
  const minutes = Math.floor(timeInSeconds / 60)

  return `${minutes}:${formatNumAsTwoDigits(seconds)}`
}

const formatNumAsTwoDigits = n => `0${n}`.slice(-2)

function MarkDetails({ handleClick, mark, onDelete, onEditClick }) {
  return (
    <li className="vi-marks clearfix">
      <div className="vi-mark-detail" onClick={() => handleClick(mark)}>
        <h6>{mark.text}</h6>
        <p>{formatTime(mark.secondsAfterStart)}</p>
      </div>
      <div className="vi-actions">
        <Icon name="edit" onClick={() => onEditClick()} />
        <Icon name="delete" onClick={() => onDelete(mark)} />
      </div>
    </li>
  )
}

MarkDetails.propTypes = {
  handleClick: PropTypes.func.isRequired,
  mark: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired
}

export default MarkDetails



// WEBPACK FOOTER //
// ../src/components/MarkDetails.js